import { Container } from 'inversify-props';
import setupNationalities from './nationalities/setup';
import setupGenders from './genders/setup';

export default function setupCatalogsModule(container: Container) {
  setupNationalities(container);
  setupGenders(container);
}
